import moment from "moment";
import setPriceWithCurrency from "../../../../Shared/utils/currency";
import { getDayBreakdown } from "../../../utils/utils";
import { DetailTexts, OrderDetailsText, OrderType, } from "./OrderDetailsAccordion-types";
import { useCartSettingsQuery } from "../../../../SWR/CartSettings/useCartSettingsQuery";
/**
 *
 * @param qty
 * @param name
 * @param noMealsSelectedText
 * @returns
 */
export const buildQuantityString = (qty, name, noMealsSelectedText) => !!name && qty >= 1 ? `${name} x${qty}.` : noMealsSelectedText;
/**
 *`
 * @param currentOrder
 * @param skippedDays
 * @returns
 */
export const buildMappedMeals = (currentOrder, skippedDays, noMealsSelectedText) => {
    const { order, orderInfo } = currentOrder;
    const { settings } = useCartSettingsQuery(orderInfo.FlowSku);
    const mealsForOrder = order.OrderIsUpcoming
        ? order.OrderMealDays.map((day) => {
            const isDaySkipped = skippedDays
                ? skippedDays.find((skipDay) => moment(skipDay.customerDate).utc().isSame(moment(day.DateFormatted).utc(), "day"))
                : false;
            const isShipDaySkipped = skippedDays
                ? skippedDays.find((skipDay) => moment(skipDay.customerDate).utc().isSame(moment(day.ShipDate).utc(), "day"))
                : false;
            return [
                {
                    day: day.MealDate,
                    skipped: (isDaySkipped !== null && isDaySkipped !== void 0 ? isDaySkipped : isShipDaySkipped) ? true : false,
                    meals: day.OrderMealDayDetails.map((detail) => {
                        return {
                            mealType: detail.MealName,
                            mealQuantity: detail.Quantity,
                            recipes: [{ qty: detail.Quantity, name: null, quantityString: noMealsSelectedText }],
                        };
                    }),
                },
            ];
        })
        : orderInfo.days.map((day) => getDayBreakdown(day, noMealsSelectedText, settings === null || settings === void 0 ? void 0 : settings.recipeDisplayNameType));
    const productsNotDeliveredOnMealDay = () => {
        let mealDays = [];
        mealsForOrder.forEach((day) => day.forEach((meal) => mealDays.push(meal.day)));
        let products = orderInfo.product_items.length > 0
            ? orderInfo.product_items.filter((product) => !mealDays.includes(product.deliveryDate))
            : [];
        return products;
    };
    const nonMealDayProducts = productsNotDeliveredOnMealDay();
    // aggregate all products & meals into single structure
    // so we can sort by meal date across both
    const mealSortFunc = (a, b) => { var _a, _b, _c, _d; return moment((_a = a[0]) === null || _a === void 0 ? void 0 : _a.day).isBefore(moment((_b = b[0]) === null || _b === void 0 ? void 0 : _b.day)) ? -1 : moment((_c = a[0]) === null || _c === void 0 ? void 0 : _c.day).isAfter(moment((_d = b[0]) === null || _d === void 0 ? void 0 : _d.day)) ? 1 : 0; };
    const allItems = {};
    mealsForOrder.sort(mealSortFunc).forEach((dayMealsGroup) => {
        dayMealsGroup.forEach((dayMeals) => {
            if (dayMeals.day) {
                if (allItems[dayMeals.day]) {
                    allItems[dayMeals.day]["meals"].concat(dayMeals.meals);
                }
                else {
                    allItems[dayMeals.day] = {};
                    allItems[dayMeals.day]["meals"] = dayMeals.meals;
                }
            }
        });
    });
    nonMealDayProducts.forEach((product) => {
        if (product.deliveryDate) {
            if (allItems[product.deliveryDate]) {
                allItems[product.deliveryDate]["products"].concat(product);
            }
            else {
                allItems[product.deliveryDate] = {};
                allItems[product.deliveryDate]["products"] = [product];
            }
        }
    });
    const mappedMealsByDay = Object.keys(allItems).map((mealDay) => {
        const products = allItems[mealDay]["products"];
        const meals = allItems[mealDay]["meals"];
        return {
            day: mealDay,
            orderProducts: products,
            meals: (meals === null || meals === void 0 ? void 0 : meals.length) ? meals.filter((meal) => !meal.skipped) : [],
            orderInfoProducts: {
                products: orderInfo.product_items,
                showDate: false,
                mealDay: mealDay,
            },
        };
    });
    return mappedMealsByDay;
};
/**
 *
 * @param title
 * @returns
 */
export const isOrderDetailsItem = (detail) => detail === OrderDetailsText.ORDER_DETAILS;
export const getOrderType = (currentOrder) => {
    var _a, _b, _c, _d, _e;
    // We know the order has not yet been created in the DB if it does not have an order id, in which case we use the
    // subscription_location_* information.
    const isSavedOrder = !!((_a = currentOrder.order) === null || _a === void 0 ? void 0 : _a.OrderId);
    let orderType = OrderType.DELIVERY;
    if (!isSavedOrder) {
        // We know an order is for pickup if the location name is not null.
        if (!!((_b = currentOrder.orderInfo) === null || _b === void 0 ? void 0 : _b.subscription_location_name)) {
            orderType = OrderType.PICKUP;
        }
        if (!((_c = currentOrder.orderInfo) === null || _c === void 0 ? void 0 : _c.subscription_location_name)) {
            orderType = OrderType.DELIVERY;
        }
    }
    if (isSavedOrder) {
        // We know an order is for pickup if the location name is not null.
        if (!!((_d = currentOrder.orderInfo) === null || _d === void 0 ? void 0 : _d.location_name)) {
            orderType = OrderType.PICKUP;
        }
        if (!((_e = currentOrder.orderInfo) === null || _e === void 0 ? void 0 : _e.location_name)) {
            orderType = OrderType.DELIVERY;
        }
    }
    return { orderType, isSavedOrder };
};
/**
 * Formats the address lines.
 * @param address
 * @returns
 */
export const createAddressLine = (address) => {
    if (!address)
        return DetailTexts.NO_ADDRESS;
    const { Address1, Address2, City, State, Zip } = address;
    return `${Address1 !== null && Address1 !== void 0 ? Address1 : ""}, ${!!Address2 ? `${Address2}, ` : ""} ${City !== null && City !== void 0 ? City : ""}, ${State !== null && State !== void 0 ? State : ""} ${Zip !== null && Zip !== void 0 ? Zip : ""}`;
};
/**
 * Helper function to determine and create which delivery or pickup address to use.
 * @param currentOrder
 * @returns
 */
export const getOrderTypeDetails = (currentOrder) => {
    const { orderType, isSavedOrder } = getOrderType(currentOrder);
    if (currentOrder.order.ProgramName === DetailTexts.GIFT_CARD)
        return currentOrder.orderInfo.giftCardEmail;
    // We know the order has not yet been created in the DB, in which case we use the
    // subscription_location_* information.
    if (!isSavedOrder) {
        if (orderType === OrderType.PICKUP) {
            return currentOrder.orderInfo.subscription_location_name;
        }
        if (orderType === OrderType.DELIVERY) {
            const address = currentOrder.orderInfo.subscription_address;
            return createAddressLine(address);
        }
    }
    // If the order has been created in the DB, we use the
    // orderInfo.location_name or currentOrder.orderInfo.address information.
    if (isSavedOrder) {
        if (orderType === OrderType.PICKUP) {
            return currentOrder.orderInfo.location_name;
        }
        if (orderType === OrderType.DELIVERY) {
            const address = currentOrder.orderInfo.address;
            if (!address)
                return DetailTexts.NO_ADDRESS;
            return createAddressLine(address);
        }
    }
    return DetailTexts.NO_ADDRESS;
};
/**
 *
 * @param showPriceIfZero
 * @param currentOrder
 * @param culture
 * @returns
 */
export const getOrderTotal = (showPriceIfZero, currentOrder, culture) => {
    var _a;
    const totalDayBankValue = currentOrder.orderInfo.AppliedDayBanks
        ? currentOrder.orderInfo.AppliedDayBanks.reduce(function (a, b) {
            return a + b.UsedValue;
        }, 0)
        : 0;
    const orderTotal = currentOrder.orderInfo.total - totalDayBankValue > 0 ? currentOrder.orderInfo.total - totalDayBankValue : 0;
    return ((!((_a = currentOrder.orderInfo.SkipPayment) !== null && _a !== void 0 ? _a : false) &&
        !currentOrder.order.OrderIsUpcoming &&
        currentOrder.orderInfo.total >= 0 &&
        !showPriceIfZero &&
        setPriceWithCurrency(Math.abs(orderTotal), culture)) ||
        "");
};
export const buildForWeekStartingOn = (currentOrder, startSunday = false) => {
    var _a, _b, _c, _d;
    // If the order was for a gift card, return the order date.
    if (currentOrder.order.ProgramName === DetailTexts.GIFT_CARD) {
        return moment(currentOrder.orderInfo.order_date).format("LL");
    }
    // If not a gift card, compute the start of the week and return.
    const date = ((_a = currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.order) === null || _a === void 0 ? void 0 : _a.ForWeekStartingOn)
        ? currentOrder.order.ForWeekStartingOn
        : ((_d = (_c = (_b = currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.orderInfo) === null || _b === void 0 ? void 0 : _b.days) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.delivery_date)
            ? currentOrder.orderInfo.days[0].delivery_date
            : "";
    if (!!date) {
        return moment(date)
            .startOf("week")
            .add(startSunday ? 0 : 1, "d")
            .format("LL");
    }
    else
        return "";
};
